/* eslint-disable import/no-anonymous-default-export */
import axios from '../BASE_API'
import AuthHeader from '../AuthHeader'
import { PermissionPost, PermissionUpdate } from '../../app/models/SuperAdminPermission'

// class define
class PermissionService {

  getPermissionList = (data: any) => {
    return axios.post('/permission/list', data, {headers: AuthHeader()})
  }

  addPermission = (data: PermissionPost) => {
    return axios.post('/permission/add', data, {headers: AuthHeader()})
  }

  updatePermission = (data: PermissionUpdate) => {
    return axios.put('/permission/update', data, {headers: AuthHeader()})
  }
 
  deletePermission = (id: number) => {
    return axios.delete(`/permission/delete`, {
      data: {
        id: id.toString(),
      },
      headers: AuthHeader(),
    })
  }

  changePermission = (id: number) => {
    return axios.put(`/permission/changeStatus`, { id: id }, {headers: AuthHeader()})
  }


}

export default new PermissionService()
